export default "/images/c57b05a7d35d879f5568490e7123024a.avif";